<template>
  <div class="flex flex-col my-1">
    <label class="text-sm" :for="name" :class="{ 'error-input': error !== '' }">
      {{ label }}
    </label>
    <input
      ref="input"
      :type="type"
      :class="customClass"
      :value="value"
      :step="step"
      :disabled="disabled"
      :name="name"
      @input="
        ev => {
          $emit('input', ev.target.value);
        }
      "
    />
    <span v-if="error !== ''" class="error-input">
      {{ error }}
    </span>
  </div>
</template>
<script>
export default {
  name: "TextField",
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    label: {
      type: String,
      default: ""
    },
    step: {
      type: String,
      default: "1"
    },
    type: {
      type: String,
      default: ""
    },
    customClass: {
      type: String,
      default: "bordered"
    },
    rules: {
      type: Array,
      default() {
        return [];
      }
    },
    required: {
      type: [Array, String],
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      error: ""
    };
  },
  computed: {
    name() {
      if (this.label && this.label != "") {
        return this.label.toLowerCase().replace(/\s|-/g, "_");
      }
      return "";
    }
  },
  watch: {
    value() {
      this.validate();
    }
  },
  methods: {
    reset() {
      this.$nextTick().then(() => {
        this.error = "";
      });
      console.log(`base text field reset ${this.name}`);
    },
    validate() {
      let valid = true;
      if (this.value !== "") {
        this.rules.forEach((rule, index, arr) => {
          valid = rule(this.value);
          if (valid !== true) {
            this.error = valid;
            arr.length = index + 1;
            valid = false;
          }
        });
        if (valid === true) {
          this.error = "";
        }
      } else {
        if (Array.isArray(this.required) && this.required.length > 0) {
          let valid = this.required[0](this.value);
          if (valid === true) {
            this.error = "";
            return true;
          } else {
            this.error = valid;
            valid = false;
          }
        } else {
          if (this.required === "") {
            if (this.value === "") {
              this.error = "This field is required";
              valid = false;
            } else {
              this.error = "";
            }
          }
        }
      }
      return valid;
    }
  }
};
</script>
